import { heroData } from "@/mocks/homeData";

export default function Hero() {
  const { tag, siteName, corePosition, slogans, description, stats, primaryCta, secondaryCta } = heroData;

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden pt-16"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20atmosphere%20with%20soft%20theater%20curtain%20texture%2C%20subtle%20film%20grain%2C%20warm%20spotlight%20glow%20on%20dark%20background%2C%20elegant%20movie%20theater%20ambience%2C%20abstract%20cinematic%20composition&width=1600&height=900&seq=hero-bg-movie-01&orientation=landscape"
          alt="天美麻花星空影视背景"
          className="w-full h-full object-cover object-top"
          onError={(e) => {
            (e.currentTarget.parentElement as HTMLElement).style.display = "none";
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-400 text-xs md:text-sm font-medium mb-4 whitespace-nowrap">
              {tag}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-50 leading-tight mb-3">
              {siteName}
              <br />
              <span className="text-primary-500">{corePosition}</span>
            </h1>

            <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-2">
              {slogans.join(" · ")}
            </p>

            <p className="text-foreground-500 text-xs md:text-sm leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              {description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-primary-500 font-heading text-lg md:text-2xl">{stat.value}</div>
                  <div className="text-foreground-500 text-xs">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={primaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector(primaryCta.href)?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-fill"></i>
                </span>
                {primaryCta.text}
              </a>
              <a
                href={secondaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector(secondaryCta.href)?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300/30 text-foreground-300 hover:text-foreground-50 hover:border-foreground-300/60 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-line"></i>
                </span>
                {secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20collage%20design%20with%20film%20strip%20borders%2C%20dramatic%20lighting%2C%20golden%20and%20amber%20accents%20on%20dark%20background%2C%20elegant%20typography%20style%2C%20vintage%20cinema%20poster%20aesthetic&width=900&height=1200&seq=hero-poster-01&orientation=portrait"
                alt="天美麻花星空影视 - 精选影片合集"
                className="w-full h-auto rounded-lg"
                onError={(e) => {
                  (e.currentTarget.parentElement as HTMLElement).style.display = "none";
                }}
              />
              <div className="absolute inset-0 rounded-lg ring-1 ring-inset ring-foreground-200/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}